import { render, staticRenderFns } from "./CarouselVertical.vue?vue&type=template&id=6ae1f0d3&"
import script from "./CarouselVertical.vue?vue&type=script&lang=js&"
export * from "./CarouselVertical.vue?vue&type=script&lang=js&"
import style0 from "./CarouselVertical.vue?vue&type=style&index=0&id=6ae1f0d3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports